export default __webpack_public_path__ + "static/media/jerai-logo-small.01e05c06.png";